import { createNullableProvideInject } from '@collector/shared-ui'

import { IncidentsResultConfig } from '../configuration'

export const [provideIncidentsResultConfig, injectIncidentsResultConfig] =
  createNullableProvideInject<IncidentsResultConfig>('incidentsResultConfig')
